import { render, staticRenderFns } from "./OpenIDView.vue?vue&type=template&id=55c985b9&"
import script from "./OpenIDView.vue?vue&type=script&lang=ts&"
export * from "./OpenIDView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports